import { name } from "./organizations.reducers";
export const selectSlice = (state) => state[name];

export const selectOrganizations = (state) => selectSlice(state).organizations;

export const selectOrganizationUsers = (state) =>
  selectSlice(state).selectOrganizationUsers;

export const selectSelectedOrganizationId = (state) =>
  selectSlice(state).selectedOrganizationId;

export const selectSelectedOrganization = (state) =>
  selectSlice(state).selectedOrganization;

export const selectOrganizationsFilters = (state) =>
  selectSlice(state).organizationsFilters;

export const selectOrganizationUsersFilters = (state) =>
  selectSlice(state).organizationUsersFilters;

export const selectOrganizationUsersId = (state) =>
  selectSlice(state).organizationUsersId;
